import { MODALS } from 'src/models/ModalModel';
import ModalBase from 'src/components/Modals/ModalBase';
import { MODALS_SIZE } from 'src/models/modal';
import { FORM } from 'src/constants/Form';
import ManageAccounts from 'src/components/Elements/ManageAccounts';

const AccountManagementModal = () => (
  <ModalBase
    name={MODALS.manageAccounts}
    size={MODALS_SIZE.small}
    form={FORM.get_accounts}>
    <ManageAccounts />
  </ModalBase>
);

export default AccountManagementModal;
